var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ctm-multi-product-preview" },
    [
      _vm.field.select_type !== "select"
        ? _c(
            "div",
            {
              class: [
                "ctm-multi-product",
                "ctm-multi-product--" + (_vm.field.select_type || "radio")
              ]
            },
            _vm._l(_vm.field.options, function(option, idx) {
              return _c(
                "div",
                {
                  key: idx,
                  class: [
                    "ctm-product-card",
                    _vm.isSelected(option.name)
                      ? "ctm-product-card--selected"
                      : ""
                  ]
                },
                [
                  _vm.field.photo_value && option.photo
                    ? _c("div", { staticClass: "ctm-product-card__img" }, [
                        _c("img", {
                          attrs: { src: option.photo, alt: option.name }
                        })
                      ])
                    : _vm.field.photo_value
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "ctm-product-card__img ctm-product-card__img--placeholder"
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "1.5"
                              }
                            },
                            [
                              _c("rect", {
                                attrs: {
                                  x: "3",
                                  y: "3",
                                  width: "18",
                                  height: "18",
                                  rx: "2"
                                }
                              }),
                              _vm._v(" "),
                              _c("circle", {
                                attrs: { cx: "8.5", cy: "8.5", r: "1.5" }
                              }),
                              _vm._v(" "),
                              _c("path", { attrs: { d: "M21 15l-5-5L5 21" } })
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "ctm-product-card__body" }, [
                    _c("span", { staticClass: "ctm-product-card__name" }, [
                      _vm._v(_vm._s(option.name))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "ctm-product-card__price" }, [
                      _vm._v("$" + _vm._s(_vm.formatPrice(option.price)))
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "ctm-product-card__check",
                      attrs: { "aria-hidden": "true" }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.field.select_type === "checkbox" ? "✓" : "●"
                          ) +
                          "\n      "
                      )
                    ]
                  )
                ]
              )
            }),
            0
          )
        : _c(
            "el-select",
            {
              staticStyle: { width: "100%", "max-width": "320px" },
              attrs: { disabled: "", placeholder: "— Select a product —" }
            },
            _vm._l(_vm.field.options, function(option, idx) {
              return _c("el-option", {
                key: idx,
                attrs: {
                  label: option.name + "  —  $" + _vm.formatPrice(option.price),
                  value: option.name
                }
              })
            }),
            1
          ),
      _vm._v(" "),
      _vm.field.help
        ? _c("span", { staticClass: "contactum-help" }, [
            _vm._v(_vm._s(_vm.field.help))
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }